import React from 'react';
import { ShieldCheckIcon, LockIcon, CreditCardIcon } from 'lucide-react';
const stats = [{
  value: '+1.200',
  label: 'docentes'
}, {
  value: '6',
  label: 'tomos listos'
}, {
  value: '240 h',
  label: 'ahorradas / año'
}, {
  value: '4.9/5',
  label: '⭐ valoración'
}];
export function Stats() {
  return <section className="border-y border-navy/10 bg-white px-4 py-8" data-id="element-186">
      <div className="mx-auto max-w-4xl" data-id="element-187">
        <div className="mb-6 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-semibold text-navy/70 sm:text-sm" data-id="element-188">
          <span className="inline-flex items-center gap-1.5" data-id="element-189">
            <ShieldCheckIcon className="h-4 w-4 text-teal" data-id="element-190" /> Garantía 7 días
          </span>
          <span className="inline-flex items-center gap-1.5" data-id="element-191">
            <LockIcon className="h-4 w-4 text-brandpurple" data-id="element-192" /> Pago seguro
          </span>
          <span className="inline-flex items-center gap-1.5" data-id="element-193">
            <CreditCardIcon className="h-4 w-4 text-magenta" data-id="element-194" /> Múltiples medios
          </span>
        </div>
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-4" data-id="element-195">
          {stats.map(s => <div key={s.label} className="rounded-2xl bg-cream px-3 py-4 text-center" data-id="element-196">
              <div className="font-display text-2xl font-black text-navy sm:text-3xl" data-id="element-197">
                {s.value}
              </div>
              <div className="mt-1 text-[11px] font-semibold uppercase tracking-wide text-navy/55 sm:text-xs" data-id="element-198">
                {s.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}